import ServicePageTemplate from "@/components/ServicePageTemplate";
import { Helmet } from "react-helmet-async";
import { Bot, Zap, Globe, Code, Cpu, Sparkles } from "lucide-react";

const subServices = ["Automation", "AI Landing Pages", "AI Tools"];

const features = [
  {
    icon: Zap,
    title: "Business Automation",
    description: "Automate repetitive tasks and workflows to save time and reduce errors.",
  },
  {
    icon: Globe,
    title: "AI Landing Pages",
    description: "High-converting landing pages built with AI assistance for faster deployment.",
  },
  {
    icon: Cpu,
    title: "AI Tools Integration",
    description: "Integrate cutting-edge AI tools into your business for enhanced productivity.",
  },
  {
    icon: Code,
    title: "Custom AI Solutions",
    description: "Bespoke AI solutions tailored to your specific business challenges.",
  },
  {
    icon: Sparkles,
    title: "Content Automation",
    description: "AI-powered content generation and optimization for marketing.",
  },
  {
    icon: Bot,
    title: "Chatbots & Assistants",
    description: "Intelligent chatbots and virtual assistants for customer support.",
  },
];

const benefits = [
  {
    title: "Time Savings",
    description: "Automate hours of manual work and focus on what matters most.",
  },
  {
    title: "Cost Reduction",
    description: "Reduce operational costs by automating repetitive processes.",
  },
  {
    title: "Competitive Edge",
    description: "Stay ahead of competitors with cutting-edge AI technology.",
  },
  {
    title: "Scalability",
    description: "AI solutions that grow with your business without adding headcount.",
  },
];

const process = [
  {
    title: "Audit",
    description: "Analyzing your current processes to identify automation opportunities.",
  },
  {
    title: "Design",
    description: "Creating AI solutions tailored to your specific needs and goals.",
  },
  {
    title: "Build",
    description: "Implementing and integrating AI tools into your workflow.",
  },
  {
    title: "Optimize",
    description: "Continuous improvement and optimization of AI systems.",
  },
];

export default function AIServices() {
  return (
    <>
      <Helmet>
        <title>AI Solutions for Small Business | Chatbots & Automation | Barton</title>
        <meta name="description" content="Harness the power of AI for your business. We implement chatbots, automation tools, and AI-powered solutions to save time and boost efficiency." />
        <meta property="og:title" content="AI Solutions for Small Business | Barton" />
        <meta property="og:description" content="Harness AI for your business. Chatbots, automation tools, and AI-powered solutions to boost efficiency." />
        <meta property="og:url" content="https://barton.uk/services/ai-services" />
        <meta property="og:image" content="https://barton.uk/og-image.png" />
        <meta name="twitter:title" content="AI Solutions for Small Business | Barton" />
        <meta name="twitter:description" content="Chatbots, automation tools, and AI-powered solutions for small businesses." />
        <meta name="twitter:image" content="https://barton.uk/og-image.png" />
      </Helmet>
      <ServicePageTemplate
        title="AI Services"
        subtitle="Future-Proof Your Business"
        description="Harness the power of artificial intelligence to automate tasks, create landing pages, and integrate cutting-edge AI tools that give your business a competitive edge."
        image="https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&q=80"
        icon={Bot}
        features={features}
        benefits={benefits}
        process={process}
        subServices={subServices}
        ctaText="Get In Touch"
        accentColor="pink"
      />
    </>
  );
}
